// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".PrintHelper__printHelperContainerIframe___1Ppn3{border:none;height:0;width:0}", ""]);
// Exports
exports.locals = {
	"printHelperContainerIframe": "PrintHelper__printHelperContainerIframe___1Ppn3"
};
module.exports = exports;
